// Translated service page content for EN, FR, DE
// Dutch (NL) content is the base in servicesData and doesn't need translation here

const serviceTranslations = {
  en: {
    "vakantiehuizen": {
      title: "Vacation Home Service",
      subtitle: "Complete cleaning, laundry and guest check-in for vacation rentals",
      intro: "As a vacation home owner, you know how important a clean and welcoming space is for positive reviews and returning guests. Our Vacation Home Service offers a complete solution: professional cleaning, laundry services and guest check-in between every changeover.",
      benefits: [
        { title: "Time Saving", text: "No more cleaning, doing laundry or greeting guests yourself. We handle everything between bookings." },
        { title: "Higher Reviews", text: "A spotless home and personal welcome lead to better reviews and more bookings." },
        { title: "Flexible Planning", text: "We coordinate with your booking calendar, even for last-minute changeovers." },
        { title: "Reliable Team", text: "Dedicated staff who know your property and work from a checklist." }
      ],
      whatWeOffer: [
        "Thorough cleaning of all rooms, kitchen and bathrooms",
        "Changing bed linen with fresh, washed linens",
        "Replacing and neatly hanging towels",
        "Emptying bins and removing waste",
        "Checking supplies (toilet paper, soap, coffee etc.)",
        "Checking appliances (fridge, oven, coffee machine)",
        "Window cleaning if needed",
        "Laundry: washing, drying and ironing all used textiles",
        "Quality control with photo report",
        "Guest check-in: personal welcome with key handover and house tour",
        "Guest check-in: key placed in keybox with instructions"
      ],
      pricing: `
        <strong>ALL-IN PRICE per changeover (excl. VAT):</strong><br>
        <span style="color: #A1A1AA;">Includes: cleaning, bed making, towels, kitchen, bathroom.</span><br><br>
        <strong>Studio/apartment up to 50m²:</strong> 1 BR: €65<br>
        <strong>Apartment 50-80m²:</strong> 1 BR: €80 / 2 BR: €95<br>
        <strong>House 80-120m²:</strong> 2 BR: €120 / 3 BR: €145 / 4 BR: €160<br>
        <strong>Large house 120-180m²:</strong> 3 BR: €175 / 4 BR: €195 / 5 BR: €220<br>
        <strong>Villa >180m²:</strong> from €230 — custom quote<br><br>
        <hr style="border-color: rgba(255,255,255,0.2); margin: 16px 0;">
        <strong>GUEST CHECK-IN SERVICE (bookable separately):</strong><br><br>
        <strong>Option 1 - Personal Welcome:</strong> €45.00<br>
        <span style="color: #A1A1AA;">Staff member welcomes guests, hands over keys, gives house tour and explains house rules. (1 hour)</span><br><br>
        <strong>Option 2 - Key Handover:</strong> €20.00<br>
        <span style="color: #A1A1AA;">Key placed in keybox/drop-off point, instructions left for guests.</span><br><br>
        <hr style="border-color: rgba(255,255,255,0.2); margin: 16px 0;">
        <strong>LAUNDRY SURCHARGE:</strong> €6.00/kg<br><br>
        <strong>DISCOUNTS:</strong><br>
        - Check-in + cleaning on the same day: €10.00 off check-in<br>
        - 10+ changeovers/month: 15% discount<br>
        - 20+ changeovers/month: 20% discount
      `
    },
    "kantoorschoonmaak": {
      title: "Office Cleaning",
      subtitle: "Professional cleaning for a productive work environment",
      intro: "A clean office is essential for the health, productivity and image of your business. Our professional office cleaning ensures a hygienic and presentable workplace on a daily or periodic basis.",
      benefits: [
        { title: "Healthier Employees", text: "Less sick leave through a hygienic work environment." },
        { title: "Professional Image", text: "Impress clients and visitors with a well-maintained office." },
        { title: "Flexible Hours", text: "Cleaning outside office hours so you won't be disturbed." },
        { title: "Reliable & Discreet", text: "Screened staff who handle your premises with confidentiality." }
      ],
      whatWeOffer: [
        "Daily vacuuming and mopping of floors",
        "Dusting desks, cabinets and surfaces",
        "Emptying waste bins and paper bins",
        "Cleaning sanitary facilities",
        "Cleaning kitchen and canteen areas",
        "Window cleaning (interior and exterior)",
        "Deep cleaning of carpets and flooring",
        "Periodic deep cleaning",
        "Disinfection of contact points (door handles, light switches)"
      ],
      pricing: "Price depends on office size, frequency and required services. Request a quote."
    },
    "industriele-reiniging": {
      title: "Industrial Cleaning",
      subtitle: "Specialist cleaning for factories and warehouses",
      intro: "Industrial environments demand high cleaning standards. From production halls to warehouses - our specialists have the knowledge and equipment for thorough, safe and efficient cleaning.",
      benefits: [
        { title: "Safety First", text: "Prevent accidents from slippery floors or scattered waste." },
        { title: "Fewer Breakdowns", text: "Clean machines and installations work better and last longer." },
        { title: "Standards Compliant", text: "Meet HACCP, IFS and other hygiene standards." },
        { title: "Minimal Downtime", text: "We work at night or during off-peak hours." }
      ],
      whatWeOffer: [
        "Cleaning machines and production lines",
        "Cleaning warehouse shelving and racks",
        "Floor cleaning with industrial scrubbing machines",
        "Steam cleaning for chemical-free disinfection",
        "High-pressure cleaning of surfaces",
        "Removal of oil, grease and production residues",
        "Cleaning of pipes, tanks and fittings",
        "Waste management and tidying",
        "Periodic deep cleaning"
      ],
      pricing: "Price on request, depending on surface area, type of contamination and frequency."
    },
    "ramenwassen-osmose": {
      title: "Osmosis Window Cleaning",
      subtitle: "Streak-free results with pure osmosis water",
      intro: "Osmosis window cleaning is the modern, eco-friendly way to achieve crystal clear windows. Tap water is forced under high pressure through a fine membrane, filtering out virtually all minerals and impurities. The result is ultra-pure water that attracts dirt from the glass and dries completely streak-free — without any cleaning agents.",
      warning: "Osmosis water must NOT be used on gold-coloured aluminium window frames! The pure water can damage the gold coating. Do you have gold-coloured frames? Contact us for an alternative solution.",
      benefits: [
        { title: "100% Streak-Free", text: "Osmosis water dries without streaks or limescale marks." },
        { title: "Eco-Friendly", text: "No chemicals, safe for people, animals and plants." },
        { title: "Stays Clean Longer", text: "Windows stay cleaner longer as no soap residue attracts dirt." },
        { title: "Safe Working", text: "Up to 6 metres high without a ladder thanks to telescopic system." }
      ],
      whatWeOffer: [
        "Window cleaning with purified osmosis water",
        "Telescopic system up to 6 metres - no ladder needed",
        "All window types: standard, sliding doors, skylights",
        "Frames and window sills included",
        "No chemicals or aggressive agents",
        "Suitable for homes, offices and shops",
        "Subscription discounts available",
        "Alternative for gold-coloured aluminium frames available"
      ],
      pricing: `
        <div style="background: rgba(239, 68, 68, 0.1); border: 1px solid rgba(239, 68, 68, 0.3); border-radius: 8px; padding: 16px; margin-bottom: 20px;">
          <strong style="color: #EF4444;">WARNING - GOLD-COLOURED ALUMINIUM</strong><br>
          <span style="color: #FCA5A5;">Osmosis water must NOT be used on gold-coloured aluminium window frames. For gold-coloured aluminium, we use traditional manual cleaning (see prices below).</span>
        </div>
        <strong>OSMOSIS PRICES per window (excl. VAT):</strong><br>
        <em>Standard method - not for gold-coloured aluminium</em><br><br>
        <strong>Standard window (up to 1.5m²):</strong><br>
        • Exterior: €4.50<br>• Interior: €3.00<br>• Interior + exterior: €7.00<br><br>
        <strong>Large window (sliding door, 1.5-3m²):</strong><br>
        • Exterior: €9.00<br>• Interior: €5.00<br>• Interior + exterior: €13.00<br><br>
        <strong>Skylight/roof window:</strong><br>
        • Exterior: €10.00<br>• Interior + exterior: €15.00<br><br>
        <hr style="border-color: rgba(255,255,255,0.2); margin: 20px 0;">
        <strong>TRADITIONAL MANUAL per window (excl. VAT):</strong><br>
        <em>For gold-coloured aluminium frames</em><br><br>
        <strong>Standard window (up to 1.5m²):</strong><br>
        • Exterior: €5.50<br>• Interior: €3.50<br>• Interior + exterior: €8.50<br><br>
        <strong>Large window (sliding door, 1.5-3m²):</strong><br>
        • Exterior: €11.00<br>• Interior: €6.00<br>• Interior + exterior: €16.00<br><br>
        <strong>Skylight/roof window:</strong><br>
        • Exterior: €12.00<br>• Interior + exterior: €18.00<br><br>
        <hr style="border-color: rgba(255,255,255,0.2); margin: 20px 0;">
        <strong>EXTRA LARGE WINDOWS (≥ 4m², shop fronts, glass facades) per m²:</strong><br><br>
        <strong>Osmosis (excl. VAT):</strong><br>
        • Exterior: €2.00–€2.50/m²<br>
        • Volume/business (lots of glass): €1.60–€2.00/m²<br>
        • Interior + exterior: €3.00–€4.00/m²<br><br>
        <strong>Traditional manual (excl. VAT):</strong><br>
        • Exterior: €2.50–€3.00/m²<br>
        • Interior + exterior: €3.50–€4.50/m²<br><br>
        <hr style="border-color: rgba(255,255,255,0.2); margin: 20px 0;">
        Minimum charge: €35.00 per visit<br>
        Travel costs: free up to 15 km
      `
    },
    "zonnepanelen-reiniging": {
      title: "Solar Panel Cleaning",
      subtitle: "Increase your yield up to 30% with clean panels",
      intro: "Dirty solar panels produce less energy. Dust, bird droppings, leaves and Sahara sand can reduce output by 5-20%. Our professional cleaning with osmosis water restores optimal performance of your installation.",
      benefits: [
        { title: "More Output", text: "Clean panels deliver up to 15-20% more energy." },
        { title: "Longer Lifespan", text: "Prevent permanent damage from bird droppings and dirt." },
        { title: "Osmosis Water", text: "No chemicals, safe for your panels and the environment." },
        { title: "Warranty Preserved", text: "Many manufacturers require maintenance for warranty coverage." }
      ],
      whatWeOffer: [
        "Cleaning with pure osmosis water (no chemicals)",
        "Safe working with telescopic system",
        "Inspection for visible damage",
        "Suitable for all types of panels",
        "Residential and commercial installations",
        "Annual maintenance subscription available",
        "Flexible scheduling in spring or late summer"
      ],
      pricing: "Price depends on number of panels and accessibility. Average €3-5 per panel. Request a quote."
    },
    "wasserijdiensten": {
      title: "Laundry Services",
      subtitle: "Professional textile care via HomeCareService",
      intro: "Our laundry services via HomeCareService provide professional textile care for businesses. From workwear to linen - we take care of collecting, washing, drying, ironing and returning your textiles.",
      benefits: [
        { title: "Time Saving", text: "Focus on your core activities, we handle the laundry." },
        { title: "Professional Quality", text: "Industrial machines and expertise for perfect results." },
        { title: "Eco-Conscious", text: "Energy-efficient machines and environmentally friendly products." },
        { title: "Personal Service", text: "Dedicated contact person and flexible collection schedules." }
      ],
      whatWeOffer: [
        "Collection and delivery on location",
        "Washing, drying and ironing",
        "Workwear and uniforms",
        "Bed linen and towels",
        "Tablecloths and napkins (hospitality)",
        "Inspection and minor repairs",
        "Flexible frequency: daily to weekly"
      ],
      pricing: `
        <strong>B2B Rate:</strong><br>
        Washing, drying and ironing: <strong>€6.- per kg</strong> (excl. VAT)<br><br>
        <a href="https://homecareservice.me/prijslijst-1" target="_blank" rel="noopener noreferrer" class="text-[#4DD0E1] hover:underline">
          → View the full price list at HomeCareService
        </a>
      `
    },
    "glazenwassen": {
      title: "Traditional Window Cleaning",
      subtitle: "Classic window cleaning for crystal clear windows",
      intro: "In addition to osmosis window cleaning, we also offer traditional window cleaning. This method is ideal for specific situations such as interior windows or when manual finishing is desired.",
      benefits: [
        { title: "Detailed Work", text: "Manual finishing for perfect corners and edges." },
        { title: "Interior Specialist", text: "Ideal for interior windows without water droplets." },
        { title: "Experienced Professionals", text: "Years of experience with all types of glass." },
        { title: "Reliable", text: "The same quality you've come to expect from us." }
      ],
      whatWeOffer: [
        "Traditional window cleaning with squeegee and cloth",
        "Interior window cleaning",
        "Mirrors and glass partitions",
        "Hard-to-reach corners",
        "Combination with osmosis for exterior",
        "Offices, shops and homes"
      ],
      pricing: `
        <strong>Prices per window (excl. VAT):</strong><br><br>
        <strong>Standard window (up to 1.5m²):</strong><br>
        • Interior: €3.00<br><br>
        <strong>Large window (1.5-3m²):</strong><br>
        • Interior: €5.00<br><br>
        <strong>Extra large window (≥ 4m², shop fronts, facades):</strong><br>
        • Interior: €2.00–€2.50/m²<br>
        • Interior + exterior: €3.00–€4.00/m²<br><br>
        Exterior is always cleaned with osmosis.
      `
    },
    "sanering-desinfectie": {
      title: "Sanitation & Disinfection Cleaning",
      subtitle: "Professional cleaning after toilet blockages, pipe bursts and sewage water damage",
      intro: "Water damage from a blocked toilet, burst pipe or sewer break is not only unpleasant — it can also pose a serious health risk. Sewage water contains bacteria, viruses and fungi that must be professionally removed. Clean-Force provides fast and thorough sanitation and disinfection cleaning to make your space safe and hygienic again.",
      benefits: [
        { title: "Rapid Response", text: "We respond quickly to emergencies. We understand that every minute counts with water damage." },
        { title: "Certified Disinfection", text: "We use professional disinfectants that effectively eliminate bacteria, viruses and fungi." },
        { title: "Specialized Team", text: "Our staff are trained in post-flood sanitation and work with proper protective equipment." },
        { title: "Complete Restoration", text: "From pumping out water to disinfection and odor treatment — we ensure your space is 100% clean and safe." }
      ],
      whatWeOffer: [
        "Inspection and damage assessment",
        "Removal of contaminated water and waste",
        "Thorough cleaning of all affected surfaces",
        "Professional disinfection with certified products",
        "Mold prevention and odor treatment",
        "Cleaning and disinfection of sanitary facilities",
        "Cleaning floors, walls and baseboards after leakage",
        "Drying and ventilation advice",
        "Documentation and reporting for insurance claims",
        "Follow-up care and post-treatment inspection"
      ],
      pricing: `
        <strong>SANITATION & DISINFECTION RATES (excl. VAT):</strong><br>
        <span style="color: #A1A1AA;">Prices depend on the extent and severity of contamination. Below are our guide prices.</span><br><br>
        <hr style="border-color: rgba(255,255,255,0.2); margin: 16px 0;">
        <strong>Starting rate (first hour, incl. travel costs):</strong> €149.00<br>
        <span style="color: #A1A1AA;">Including inspection, materials and initial work.</span><br><br>
        <strong>Continuation per quarter hour:</strong> €32.50<br><br>
        <hr style="border-color: rgba(255,255,255,0.2); margin: 16px 0;">
        <strong>PACKAGE RATES:</strong><br><br>
        <strong>Toilet blockage + disinfection:</strong> from €175.00<br>
        <span style="color: #A1A1AA;">Including unblocking, cleaning and disinfection of sanitary area.</span><br><br>
        <strong>Pipe burst / leak — small area (up to 20m²):</strong> from €350.00<br>
        <span style="color: #A1A1AA;">Removal of contaminated water, cleaning, disinfection and odor treatment.</span><br><br>
        <strong>Sewage water damage — medium area (20-60m²):</strong> from €750.00<br>
        <span style="color: #A1A1AA;">Complete sanitation including pumping, cleaning and professional disinfection.</span><br><br>
        <strong>Large sanitation (>60m² or multiple rooms):</strong> custom quote<br>
        <span style="color: #A1A1AA;">We come for a free inspection and tailored quote.</span><br><br>
        <hr style="border-color: rgba(255,255,255,0.2); margin: 16px 0;">
        <strong>SURCHARGES:</strong><br>
        • Evening (18:00 - 22:00): +25%<br>
        • Weekend: +50%<br>
        • Urgent / holidays: +75%<br><br>
        <span style="color: #A1A1AA;">Tip: Many sanitation costs are covered by your home contents or building insurance. We provide the necessary documentation for your claim.</span>
      `
    },
    "bouwoplevering": {
      title: "Post-Construction Cleaning",
      subtitle: "Move-in ready handover cleaning after new builds or renovations",
      intro: "After construction or renovation work, your property is full of building dust, cement residue, paint spatters and protective film. Clean-Force delivers a move-in ready handover cleaning so you or your client can move into a clean and fresh property.",
      benefits: [
        { title: "Thorough Dust Removal", text: "Building dust gets everywhere — we remove it from every corner, ledge and ventilation grille." },
        { title: "Professional Products", text: "Cement residue, limescale and paint spatters are removed with specialist products without damage." },
        { title: "Timely Delivery", text: "We work quickly and efficiently so your handover date is not at risk." },
        { title: "Move-in Ready Result", text: "Your property is delivered as if it was never a building site. Immediately livable." }
      ],
      whatWeOffer: [
        "Removal of rough building debris and protective film",
        "Intensive dust removal from all surfaces",
        "Interior window cleaning (incl. frames and sills)",
        "Removal of cement, lime and paint spatters",
        "Cleaning of sanitary facilities (toilets, sinks, showers, taps)",
        "Thorough kitchen cleaning (cabinets inside/outside, appliances, countertops)",
        "Floor cleaning and mopping (tiles, parquet, laminate)",
        "Baseboards, door frames and light switches wiping",
        "Stair railings and balustrades cleaning",
        "Ventilation grilles and radiators dusting"
      ],
      pricing: `
        <strong>POST-CONSTRUCTION CLEANING RATES (excl. VAT):</strong><br><br>
        <strong>Hourly rate specialized cleaning:</strong><br>
        From €45.00/hour per employee<br><br>
        <hr style="border-color: rgba(255,255,255,0.2); margin: 16px 0;">
        <strong>Guide price move-in ready cleaning:</strong><br>
        From €6.00/m²<br>
        <span style="color: #A1A1AA;">Depending on level of contamination, accessibility and number of windows.</span><br><br>
        <hr style="border-color: rgba(255,255,255,0.2); margin: 16px 0;">
        Travel costs: free up to 15 km
      `
    },
    "schoonmaak-na-verhuur": {
      title: "Move-Out / Sale Cleaning",
      subtitle: "Property ready for handover after rental, sale or moving",
      intro: "When leaving a rental property, sold property or after moving, the next occupant or owner expects a clean and move-in ready home. Clean-Force provides thorough deep cleaning so you get your deposit back or your property makes a well-maintained impression at handover.",
      benefits: [
        { title: "Deposit Return Guarantee", text: "A professionally cleaned home greatly increases the chance of full deposit refund." },
        { title: "Deep Cleaning", text: "Not just surface cleaning — we clean cabinets, appliances, sanitary facilities and floors down to the smallest detail." },
        { title: "Experienced Team", text: "Our team has extensive experience with move-out and handover cleaning for both tenants and sellers." },
        { title: "Move-in Ready", text: "The next occupant can move in immediately without having to clean themselves." }
      ],
      whatWeOffer: [
        "Deep cleaning kitchen (oven, fridge, extractor hood, cabinets inside/outside)",
        "Thorough cleaning and descaling of sanitary facilities",
        "All floors vacuuming and mopping",
        "Interior window cleaning including frames",
        "Cabinets and drawers interior cleaning",
        "Baseboards, door frames and door handles wiping",
        "Light switches and sockets cleaning",
        "Cobweb removal",
        "Radiators and ventilation grilles dusting",
        "Balcony or terrace sweeping (if applicable)"
      ],
      pricing: `
        <strong>MOVE-OUT/SALE CLEANING RATES (excl. VAT):</strong><br><br>
        <strong>Hourly rate:</strong> From €45.00/hour per employee<br><br>
        <strong>Guide price per m²:</strong> From €4.00/m²<br>
        <span style="color: #A1A1AA;">For normal contamination. Heavy contamination, nicotine or lots of left-behind furniture is quoted per hour or fixed price.</span><br><br>
        <hr style="border-color: rgba(255,255,255,0.2); margin: 16px 0;">
        <strong>PACKAGE PRICES BY PROPERTY TYPE (from, excl. VAT):</strong><br><br>
        • Studio / 1 bedroom (up to 50m²): from €250<br>
        • Apartment 2-3 bedrooms (50-100m²): from €375<br>
        • Family home (100-150m²): from €550<br>
        • Large home 5-6 rooms (150-250m²): from €850<br>
        • Villa or very large home (>250m²): from €1,250<br><br>
        <strong>SURCHARGES:</strong><br>
        • Smoker's home: +25%<br>
        • Pets (extra hair/odor): +15%<br>
        • Severe neglect: custom quote<br><br>
        Travel costs: free up to 15 km
      `
    },
    "deepclean": {
      title: "Deep Clean",
      subtitle: "Thorough deep cleaning from regular to extreme contamination",
      intro: "A deep clean goes beyond standard cleaning. We clean your home or property from top to bottom, down to the smallest detail. Whether it's a regular thorough clean or a severely contaminated property — Clean-Force makes it completely clean and fresh again.",
      benefits: [
        { title: "Down to Every Detail", text: "Behind appliances, inside cabinets, above doors, under furniture — no spot is skipped." },
        { title: "Professional Products", text: "We use industrial cleaning agents that clean deeply without damaging your materials." },
        { title: "Flexibly Scheduled", text: "One-off or periodic. You decide when and how often." },
        { title: "Experienced Specialists", text: "Our team is trained in tackling heavy contamination, nicotine, grease buildup and neglect." }
      ],
      whatWeOffer: [
        "All floors thorough cleaning (vacuum, mop, machine cleaning)",
        "Kitchen deep clean (oven, fridge, extractor, cabinets, wall tiles)",
        "Sanitary deep clean and descaling (toilet, shower, bath, grout)",
        "Interior windows including frames and sills",
        "All cabinets and drawers interior cleaning",
        "Baseboards, door frames, handles and light switches",
        "Radiators and ventilation grilles deep clean",
        "Cobweb removal in all rooms",
        "Behind and under appliances/furniture",
        "Grease and nicotine removal (extreme contamination)",
        "Mould treatment in grout and corners",
        "Walls and ceilings cleaning (heavy contamination)"
      ],
      pricing: `
        <strong>DEEP CLEAN RATES (excl. VAT):</strong><br><br>
        <strong style="color: #4DD0E1;">REGULAR DEEP CLEAN</strong><br>
        • Hourly rate: from €50.00/hour per employee<br>
        • Guide price: from €5.00–€6.00/m²<br>
        • Apartment: from €500–€1,000 | Home: from €800–€1,800<br><br>
        <hr style="border-color: rgba(255,255,255,0.2); margin: 16px 0;">
        <strong style="color: #F87171;">EXTREME CONTAMINATION / NEGLECT</strong><br>
        • Hourly rate: from €60.00/hour per employee<br>
        • Guide price: from €10.00/m²<br>
        • Apartment: €900–€1,800+ | Home/villa: €1,400–€3,500+<br>
        <span style="color: #A1A1AA;">Always custom quote after inspection or photos.</span><br><br>
        <hr style="border-color: rgba(255,255,255,0.2); margin: 16px 0;">
        <strong>SURCHARGES:</strong><br>
        • Smoker's home (nicotine on walls/windows): +25%<br>
        • Pets with lots of hair/odor: +15%<br>
        • Severe neglect / lots of furniture: custom quote<br>
        <span style="color: #A1A1AA;">Total costs can reach €2,000–€5,000+ for clearance + deep cleaning combined.</span><br><br>
        Travel costs: free up to 15 km
      `
    }
  },

  fr: {
    "vakantiehuizen": {
      title: "Service Maisons de Vacances",
      subtitle: "Nettoyage complet, blanchisserie et accueil des hôtes pour locations de vacances",
      intro: "En tant que propriétaire d'une maison de vacances, vous savez à quel point un espace propre et accueillant est important pour les avis positifs et le retour des clients. Notre Service Maisons de Vacances offre une solution complète : nettoyage professionnel, services de blanchisserie et accueil des hôtes entre chaque rotation.",
      benefits: [
        { title: "Gain de Temps", text: "Plus besoin de nettoyer, faire la lessive ou accueillir les hôtes vous-même. Nous gérons tout entre les réservations." },
        { title: "Meilleurs Avis", text: "Un logement impeccable et un accueil personnalisé mènent à de meilleurs avis et plus de réservations." },
        { title: "Planning Flexible", text: "Nous nous adaptons à votre calendrier de réservations, même pour les changements de dernière minute." },
        { title: "Équipe Fiable", text: "Du personnel dédié qui connaît votre propriété et travaille selon une checklist." }
      ],
      whatWeOffer: [
        "Nettoyage approfondi de toutes les pièces, cuisine et salles de bain",
        "Changement du linge de lit avec du linge frais et lavé",
        "Remplacement et rangement soigné des serviettes",
        "Vidage des poubelles et évacuation des déchets",
        "Vérification des fournitures (papier toilette, savon, café etc.)",
        "Vérification des appareils (réfrigérateur, four, machine à café)",
        "Nettoyage des vitres si nécessaire",
        "Blanchisserie : lavage, séchage et repassage de tous les textiles utilisés",
        "Contrôle qualité avec rapport photo",
        "Accueil des hôtes : accueil personnalisé avec remise des clés et visite guidée",
        "Accueil des hôtes : clé déposée dans une boîte à clés avec instructions"
      ],
      pricing: `
        <strong>PRIX TOUT COMPRIS par rotation (hors TVA) :</strong><br>
        <span style="color: #A1A1AA;">Inclus : nettoyage, lits faits, serviettes, cuisine, salle de bain.</span><br><br>
        <strong>Studio/appartement jusqu'à 50m² :</strong> 1 ch : €65<br>
        <strong>Appartement 50-80m² :</strong> 1 ch : €80 / 2 ch : €95<br>
        <strong>Maison 80-120m² :</strong> 2 ch : €120 / 3 ch : €145 / 4 ch : €160<br>
        <strong>Grande maison 120-180m² :</strong> 3 ch : €175 / 4 ch : €195 / 5 ch : €220<br>
        <strong>Villa >180m² :</strong> à partir de €230 — devis sur mesure<br><br>
        <hr style="border-color: rgba(255,255,255,0.2); margin: 16px 0;">
        <strong>SERVICE D'ACCUEIL DES HÔTES (réservable séparément) :</strong><br><br>
        <strong>Option 1 - Accueil Personnalisé :</strong> €45,00<br>
        <span style="color: #A1A1AA;">Un collaborateur accueille les hôtes, remet les clés, fait visiter le logement et explique le règlement. (1 heure)</span><br><br>
        <strong>Option 2 - Remise des Clés :</strong> €20,00<br>
        <span style="color: #A1A1AA;">Clé déposée dans une boîte à clés/point de dépôt, instructions laissées pour les hôtes.</span><br><br>
        <hr style="border-color: rgba(255,255,255,0.2); margin: 16px 0;">
        <strong>SUPPLÉMENT BLANCHISSERIE :</strong> €6,00/kg<br><br>
        <strong>RÉDUCTIONS :</strong><br>
        - Accueil + nettoyage le même jour : €10,00 de réduction sur l'accueil<br>
        - 10+ rotations/mois : 15% de réduction<br>
        - 20+ rotations/mois : 20% de réduction
      `
    },
    "kantoorschoonmaak": {
      title: "Nettoyage de Bureaux",
      subtitle: "Nettoyage professionnel pour un environnement de travail productif",
      intro: "Un bureau propre est essentiel pour la santé, la productivité et l'image de votre entreprise. Notre nettoyage professionnel de bureaux assure quotidiennement ou périodiquement un lieu de travail hygiénique et représentatif.",
      benefits: [
        { title: "Employés Plus Sains", text: "Moins d'absentéisme grâce à un environnement de travail hygiénique." },
        { title: "Image Professionnelle", text: "Impressionnez clients et visiteurs avec un bureau soigné." },
        { title: "Horaires Flexibles", text: "Nettoyage en dehors des heures de bureau pour ne pas vous déranger." },
        { title: "Fiable et Discret", text: "Personnel vérifié qui traite vos locaux avec confidentialité." }
      ],
      whatWeOffer: [
        "Aspiration et nettoyage quotidien des sols",
        "Dépoussiérage des bureaux, armoires et surfaces",
        "Vidage des corbeilles à papier",
        "Nettoyage des sanitaires",
        "Nettoyage de la cuisine et de la cantine",
        "Lavage des vitres (intérieur et extérieur)",
        "Nettoyage en profondeur des tapis et moquettes",
        "Grand nettoyage périodique",
        "Désinfection des points de contact (poignées de porte, interrupteurs)"
      ],
      pricing: "Prix selon la taille du bureau, la fréquence et les services souhaités. Demandez un devis."
    },
    "industriele-reiniging": {
      title: "Nettoyage Industriel",
      subtitle: "Nettoyage spécialisé pour usines et entrepôts",
      intro: "Les environnements industriels exigent des normes de nettoyage élevées. Des halls de production aux entrepôts - nos spécialistes disposent des connaissances et de l'équipement pour un nettoyage approfondi, sûr et efficace.",
      benefits: [
        { title: "Sécurité Avant Tout", text: "Évitez les accidents dus aux sols glissants ou aux déchets éparpillés." },
        { title: "Moins de Pannes", text: "Des machines propres fonctionnent mieux et durent plus longtemps." },
        { title: "Conforme aux Normes", text: "Respectez les normes HACCP, IFS et autres normes d'hygiène." },
        { title: "Temps d'Arrêt Minimal", text: "Nous travaillons la nuit ou pendant les heures creuses." }
      ],
      whatWeOffer: [
        "Nettoyage des machines et lignes de production",
        "Nettoyage des rayonnages d'entrepôt",
        "Nettoyage des sols avec des autolaveuses industrielles",
        "Nettoyage vapeur pour une désinfection sans produits chimiques",
        "Nettoyage haute pression des surfaces",
        "Élimination d'huile, graisse et résidus de production",
        "Nettoyage de conduites, réservoirs et accessoires",
        "Gestion des déchets et rangement",
        "Nettoyage en profondeur périodique"
      ],
      pricing: "Prix sur demande, selon la surface, le type de contamination et la fréquence."
    },
    "ramenwassen-osmose": {
      title: "Lavage de Vitres à l'Osmose",
      subtitle: "Résultats sans traces avec de l'eau osmosée pure",
      intro: "Le lavage de vitres à l'osmose est la méthode moderne et écologique pour des fenêtres cristallines. L'eau du robinet est poussée sous haute pression à travers une membrane fine, filtrant la quasi-totalité des minéraux et impuretés. Le résultat : une eau ultra-pure qui attire la saleté du verre et sèche sans aucune trace — sans produit de nettoyage.",
      warning: "L'eau osmosée ne doit PAS être utilisée sur les cadres de fenêtres en aluminium doré ! L'eau pure peut endommager le revêtement doré. Vous avez des cadres dorés ? Contactez-nous pour une solution alternative.",
      benefits: [
        { title: "100% Sans Traces", text: "L'eau osmosée sèche sans traces ni dépôts de calcaire." },
        { title: "Écologique", text: "Aucun produit chimique, sans danger pour l'homme, les animaux et les plantes." },
        { title: "Reste Propre Plus Longtemps", text: "Les vitres restent propres plus longtemps car aucun résidu de savon n'attire la saleté." },
        { title: "Travail en Sécurité", text: "Jusqu'à 6 mètres de hauteur sans échelle grâce au système télescopique." }
      ],
      whatWeOffer: [
        "Lavage de vitres à l'eau osmosée purifiée",
        "Système télescopique jusqu'à 6 mètres - sans échelle",
        "Tous types de fenêtres : standard, baies vitrées, fenêtres de toit",
        "Cadres et rebords de fenêtres inclus",
        "Aucun produit chimique ou agressif",
        "Convient aux habitations, bureaux et commerces",
        "Abonnements avec réduction possibles",
        "Alternative disponible pour cadres en aluminium doré"
      ],
      pricing: `
        <div style="background: rgba(239, 68, 68, 0.1); border: 1px solid rgba(239, 68, 68, 0.3); border-radius: 8px; padding: 16px; margin-bottom: 20px;">
          <strong style="color: #EF4444;">ATTENTION - ALUMINIUM DORÉ</strong><br>
          <span style="color: #FCA5A5;">L'eau osmosée ne doit PAS être utilisée sur les cadres en aluminium doré. Pour l'aluminium doré, nous utilisons le nettoyage traditionnel manuel (voir tarifs ci-dessous).</span>
        </div>
        <strong>PRIX OSMOSE par fenêtre (hors TVA) :</strong><br>
        <em>Méthode standard - pas pour l'aluminium doré</em><br><br>
        <strong>Fenêtre standard (jusqu'à 1,5m²) :</strong><br>
        • Extérieur : €4,50<br>• Intérieur : €3,00<br>• Intérieur + extérieur : €7,00<br><br>
        <strong>Grande fenêtre (baie vitrée, 1,5-3m²) :</strong><br>
        • Extérieur : €9,00<br>• Intérieur : €5,00<br>• Intérieur + extérieur : €13,00<br><br>
        <strong>Fenêtre de toit/velux :</strong><br>
        • Extérieur : €10,00<br>• Intérieur + extérieur : €15,00<br><br>
        <hr style="border-color: rgba(255,255,255,0.2); margin: 20px 0;">
        <strong>TRADITIONNEL MANUEL par fenêtre (hors TVA) :</strong><br>
        <em>Pour cadres en aluminium doré</em><br><br>
        <strong>Fenêtre standard (jusqu'à 1,5m²) :</strong><br>
        • Extérieur : €5,50<br>• Intérieur : €3,50<br>• Intérieur + extérieur : €8,50<br><br>
        <strong>Grande fenêtre (baie vitrée, 1,5-3m²) :</strong><br>
        • Extérieur : €11,00<br>• Intérieur : €6,00<br>• Intérieur + extérieur : €16,00<br><br>
        <strong>Fenêtre de toit/velux :</strong><br>
        • Extérieur : €12,00<br>• Intérieur + extérieur : €18,00<br><br>
        <hr style="border-color: rgba(255,255,255,0.2); margin: 20px 0;">
        <strong>TRÈS GRANDES FENÊTRES (≥ 4m², vitrines, façades vitrées) au m² :</strong><br><br>
        <strong>Osmose (hors TVA) :</strong><br>
        • Extérieur : €2,00–€2,50/m²<br>
        • Volume/entreprises (beaucoup de verre) : €1,60–€2,00/m²<br>
        • Intérieur + extérieur : €3,00–€4,00/m²<br><br>
        <strong>Traditionnel manuel (hors TVA) :</strong><br>
        • Extérieur : €2,50–€3,00/m²<br>
        • Intérieur + extérieur : €3,50–€4,50/m²<br><br>
        <hr style="border-color: rgba(255,255,255,0.2); margin: 20px 0;">
        Tarif minimum : €35,00 par visite<br>
        Frais de déplacement : gratuit jusqu'à 15 km
      `
    },
    "zonnepanelen-reiniging": {
      title: "Nettoyage de Panneaux Solaires",
      subtitle: "Augmentez votre rendement jusqu'à 30% avec des panneaux propres",
      intro: "Des panneaux solaires sales produisent moins d'énergie. La poussière, les fientes d'oiseaux, les feuilles et le sable du Sahara peuvent réduire le rendement de 5 à 20%. Notre nettoyage professionnel à l'eau osmosée restaure le fonctionnement optimal de votre installation.",
      benefits: [
        { title: "Plus de Rendement", text: "Des panneaux propres produisent jusqu'à 15-20% d'énergie en plus." },
        { title: "Durée de Vie Plus Longue", text: "Évitez les dommages permanents causés par les fientes et la saleté." },
        { title: "Eau Osmosée", text: "Aucun produit chimique, sans danger pour vos panneaux et l'environnement." },
        { title: "Garantie Préservée", text: "De nombreux fabricants exigent un entretien pour la garantie." }
      ],
      whatWeOffer: [
        "Nettoyage à l'eau osmosée pure (sans produits chimiques)",
        "Travail en sécurité avec système télescopique",
        "Inspection des dommages visibles",
        "Convient à tous types de panneaux",
        "Installations résidentielles et commerciales",
        "Abonnement d'entretien annuel possible",
        "Planning flexible au printemps ou fin d'été"
      ],
      pricing: "Prix selon le nombre de panneaux et l'accessibilité. Moyenne €3-5 par panneau. Demandez un devis."
    },
    "wasserijdiensten": {
      title: "Services de Blanchisserie",
      subtitle: "Entretien textile professionnel via HomeCareService",
      intro: "Nos services de blanchisserie via HomeCareService offrent un entretien textile professionnel pour les entreprises. Des vêtements de travail au linge de lit - nous nous occupons de la collecte, du lavage, du séchage, du repassage et de la livraison de vos textiles.",
      benefits: [
        { title: "Gain de Temps", text: "Concentrez-vous sur vos activités principales, nous gérons la lessive." },
        { title: "Qualité Professionnelle", text: "Machines industrielles et expertise pour un résultat parfait." },
        { title: "Éco-Responsable", text: "Machines économes en énergie et produits respectueux de l'environnement." },
        { title: "Service Personnel", text: "Interlocuteur dédié et horaires de collecte flexibles." }
      ],
      whatWeOffer: [
        "Collecte et livraison sur site",
        "Lavage, séchage et repassage",
        "Vêtements de travail et uniformes",
        "Linge de lit et serviettes",
        "Nappes et serviettes (hôtellerie)",
        "Inspection et petites réparations",
        "Fréquence flexible : quotidien à hebdomadaire"
      ],
      pricing: `
        <strong>Tarif B2B :</strong><br>
        Lavage, séchage et repassage : <strong>€6,- par kg</strong> (hors TVA)<br><br>
        <a href="https://homecareservice.me/prijslijst-1" target="_blank" rel="noopener noreferrer" class="text-[#4DD0E1] hover:underline">
          → Consultez la liste de prix complète sur HomeCareService
        </a>
      `
    },
    "glazenwassen": {
      title: "Lavage de Vitres Traditionnel",
      subtitle: "Lavage de vitres classique pour des fenêtres cristallines",
      intro: "En plus du lavage de vitres à l'osmose, nous proposons également le lavage de vitres traditionnel. Cette méthode est idéale pour des situations spécifiques comme l'intérieur des fenêtres ou lorsqu'une finition manuelle est souhaitée.",
      benefits: [
        { title: "Travail Détaillé", text: "Finition manuelle pour des coins et bords parfaits." },
        { title: "Spécialiste Intérieur", text: "Idéal pour les vitres intérieures sans gouttes d'eau." },
        { title: "Professionnels Expérimentés", text: "Des années d'expérience avec tous types de verre." },
        { title: "Fiable", text: "La même qualité que vous attendez de nous." }
      ],
      whatWeOffer: [
        "Lavage de vitres traditionnel avec raclette et chamois",
        "Intérieur des fenêtres",
        "Miroirs et cloisons en verre",
        "Coins difficiles d'accès",
        "Combinaison avec osmose pour l'extérieur",
        "Bureaux, commerces et habitations"
      ],
      pricing: `
        <strong>Prix par fenêtre (hors TVA) :</strong><br><br>
        <strong>Fenêtre standard (jusqu'à 1,5m²) :</strong><br>
        • Intérieur : €3,00<br><br>
        <strong>Grande fenêtre (1,5-3m²) :</strong><br>
        • Intérieur : €5,00<br><br>
        <strong>Très grande fenêtre (≥ 4m², vitrines, façades) :</strong><br>
        • Intérieur : €2,00–€2,50/m²<br>
        • Intérieur + extérieur : €3,00–€4,00/m²<br><br>
        L'extérieur est toujours nettoyé à l'osmose.
      `
    },
    "sanering-desinfectie": {
      title: "Assainissement & Nettoyage de Désinfection",
      subtitle: "Nettoyage professionnel après obstruction de toilettes, rupture de canalisations et dégâts des eaux usées",
      intro: "Les dégâts des eaux causés par des toilettes bouchées, une canalisation éclatée ou une rupture d'égout ne sont pas seulement désagréables — ils peuvent aussi constituer un risque grave pour la santé. Les eaux usées contiennent des bactéries, des virus et des champignons qui doivent être éliminés professionnellement. Clean-Force assure un assainissement et une désinfection rapides et complets.",
      benefits: [
        { title: "Intervention Rapide", text: "Nous intervenons rapidement en cas d'urgence. Nous comprenons que chaque minute compte." },
        { title: "Désinfection Certifiée", text: "Nous utilisons des désinfectants professionnels éliminant efficacement bactéries, virus et champignons." },
        { title: "Équipe Spécialisée", text: "Notre personnel est formé à l'assainissement après inondation avec l'équipement de protection approprié." },
        { title: "Restauration Complète", text: "Du pompage à la désinfection et au traitement des odeurs — votre espace sera à nouveau propre et sûr." }
      ],
      whatWeOffer: [
        "Inspection et évaluation des dommages",
        "Élimination de l'eau contaminée et des déchets",
        "Nettoyage complet de toutes les surfaces touchées",
        "Désinfection professionnelle avec des produits certifiés",
        "Prévention des moisissures et traitement des odeurs",
        "Nettoyage et désinfection des installations sanitaires",
        "Nettoyage des sols, murs et plinthes après fuite",
        "Conseils de séchage et ventilation",
        "Documentation et rapports pour les réclamations d'assurance",
        "Suivi et inspection post-traitement"
      ],
      pricing: `
        <strong>TARIFS ASSAINISSEMENT & DÉSINFECTION (hors TVA) :</strong><br>
        <span style="color: #A1A1AA;">Les prix dépendent de l'étendue et de la gravité de la contamination.</span><br><br>
        <hr style="border-color: rgba(255,255,255,0.2); margin: 16px 0;">
        <strong>Tarif de départ (première heure, frais de déplacement inclus) :</strong> €149,00<br><br>
        <strong>Suite par quart d'heure :</strong> €32,50<br><br>
        <hr style="border-color: rgba(255,255,255,0.2); margin: 16px 0;">
        <strong>FORFAITS :</strong><br><br>
        <strong>Obstruction toilettes + désinfection :</strong> à partir de €175,00<br><br>
        <strong>Rupture canalisation — petite surface (jusqu'à 20m²) :</strong> à partir de €350,00<br><br>
        <strong>Dégâts eaux usées — surface moyenne (20-60m²) :</strong> à partir de €750,00<br><br>
        <strong>Grand assainissement (>60m² ou plusieurs pièces) :</strong> devis sur mesure<br><br>
        <hr style="border-color: rgba(255,255,255,0.2); margin: 16px 0;">
        <strong>SUPPLÉMENTS :</strong><br>
        • Soir (18h00 - 22h00) : +25%<br>
        • Week-end : +50%<br>
        • Urgent / jours fériés : +75%
      `
    },
    "bouwoplevering": {
      title: "Nettoyage de Fin de Chantier",
      subtitle: "Nettoyage de livraison prêt à emménager après construction neuve ou rénovation",
      intro: "Après des travaux de construction ou de rénovation, votre propriété est pleine de poussière de chantier, résidus de ciment et éclaboussures de peinture. Clean-Force livre un nettoyage de livraison prêt à emménager.",
      benefits: [
        { title: "Dépoussiérage Complet", text: "La poussière de chantier se niche partout — nous l'éliminons de chaque coin et recoin." },
        { title: "Produits Professionnels", text: "Résidus de ciment et éclaboussures de peinture sont éliminés avec des produits spécialisés." },
        { title: "Livraison Ponctuelle", text: "Nous travaillons rapidement pour que votre date de livraison ne soit pas en danger." },
        { title: "Résultat Prêt à Emménager", text: "Votre propriété est livrée comme si elle n'avait jamais été un chantier." }
      ],
      whatWeOffer: [
        "Enlèvement des débris de construction et films de protection",
        "Dépoussiérage intensif de toutes les surfaces",
        "Nettoyage des fenêtres intérieures (y compris cadres)",
        "Enlèvement des résidus de ciment, chaux et peinture",
        "Nettoyage des sanitaires",
        "Nettoyage complet de la cuisine",
        "Nettoyage et lavage des sols",
        "Plinthes, cadres de portes et interrupteurs",
        "Rampes d'escalier et balustrades",
        "Grilles de ventilation et radiateurs"
      ],
      pricing: `
        <strong>TARIFS NETTOYAGE FIN DE CHANTIER (hors TVA) :</strong><br><br>
        <strong>Tarif horaire :</strong> À partir de €45,00/h par employé<br><br>
        <strong>Prix indicatif :</strong> À partir de €6,00/m²<br>
        <span style="color: #A1A1AA;">Selon le degré de salissure, l'accessibilité et le nombre de fenêtres.</span><br><br>
        Frais de déplacement : gratuit jusqu'à 15 km
      `
    },
    "schoonmaak-na-verhuur": {
      title: "Nettoyage après Location/Vente",
      subtitle: "Propriété prête à remettre après location, vente ou déménagement",
      intro: "Lors du départ d'un bien loué ou vendu, le prochain occupant attend un logement propre et prêt à emménager. Clean-Force assure un nettoyage en profondeur pour récupérer votre caution ou faire bonne impression lors de la remise.",
      benefits: [
        { title: "Garantie de Caution", text: "Un logement professionnellement nettoyé augmente considérablement les chances de récupération totale de la caution." },
        { title: "Nettoyage en Profondeur", text: "Pas un simple nettoyage de surface — nous nettoyons armoires, appareils, sanitaires et sols dans les moindres détails." },
        { title: "Équipe Expérimentée", text: "Notre équipe a une vaste expérience du nettoyage de déménagement et de remise." },
        { title: "Prêt à Emménager", text: "Le prochain occupant peut emménager immédiatement." }
      ],
      whatWeOffer: [
        "Nettoyage en profondeur de la cuisine",
        "Nettoyage et détartrage complets des sanitaires",
        "Aspiration et lavage de tous les sols",
        "Nettoyage des fenêtres intérieures",
        "Nettoyage intérieur des armoires et tiroirs",
        "Plinthes et poignées de portes",
        "Interrupteurs et prises",
        "Enlèvement des toiles d'araignée",
        "Radiateurs et grilles de ventilation",
        "Balayage balcon ou terrasse"
      ],
      pricing: `
        <strong>TARIFS NETTOYAGE APRÈS LOCATION/VENTE (hors TVA) :</strong><br><br>
        <strong>Tarif horaire :</strong> À partir de €45,00/h par employé<br><br>
        <strong>Prix indicatif :</strong> À partir de €4,00/m²<br><br>
        <hr style="border-color: rgba(255,255,255,0.2); margin: 16px 0;">
        <strong>FORFAITS PAR TYPE (à partir de, hors TVA) :</strong><br><br>
        • Studio / 1 chambre (jusqu'à 50m²) : à partir de €250<br>
        • Appartement 2-3 chambres (50-100m²) : à partir de €375<br>
        • Maison familiale (100-150m²) : à partir de €550<br>
        • Grande maison (150-250m²) : à partir de €850<br>
        • Villa (>250m²) : à partir de €1.250<br><br>
        <strong>SUPPLÉMENTS :</strong><br>
        • Logement fumeur : +25%<br>
        • Animaux domestiques : +15%<br><br>
        Frais de déplacement : gratuit jusqu'à 15 km
      `
    },
    "deepclean": {
      title: "Nettoyage en Profondeur",
      subtitle: "Nettoyage approfondi, de la contamination normale à extrême",
      intro: "Un nettoyage en profondeur va au-delà d'un nettoyage standard. Nous nettoyons votre habitation de fond en comble, jusque dans les moindres détails.",
      benefits: [
        { title: "Jusque dans les Détails", text: "Derrière les appareils, dans les armoires, au-dessus des portes — aucun recoin n'est oublié." },
        { title: "Produits Professionnels", text: "Nous utilisons des produits de nettoyage industriels qui nettoient en profondeur sans endommager vos matériaux." },
        { title: "Planning Flexible", text: "Ponctuel ou périodique. Vous décidez quand et à quelle fréquence." },
        { title: "Spécialistes Expérimentés", text: "Notre équipe est formée pour traiter les contaminations lourdes, nicotine et négligence." }
      ],
      whatWeOffer: [
        "Nettoyage complet de tous les sols",
        "Nettoyage en profondeur de la cuisine",
        "Nettoyage approfondi et détartrage des sanitaires",
        "Fenêtres intérieures y compris cadres",
        "Nettoyage intérieur de toutes les armoires et tiroirs",
        "Plinthes, cadres de portes et interrupteurs",
        "Radiateurs et grilles de ventilation",
        "Enlèvement des toiles d'araignée",
        "Derrière et sous les appareils/meubles",
        "Élimination de la graisse et de la nicotine",
        "Traitement des moisissures",
        "Nettoyage des murs et plafonds"
      ],
      pricing: `
        <strong>TARIFS NETTOYAGE EN PROFONDEUR (hors TVA) :</strong><br><br>
        <strong style="color: #4DD0E1;">NORMAL</strong><br>
        • Tarif horaire : à partir de €50,00/h par employé<br>
        • Prix indicatif : à partir de €5,00–€6,00/m²<br>
        • Appartement : à partir de €500–€1.000 | Maison : à partir de €800–€1.800<br><br>
        <hr style="border-color: rgba(255,255,255,0.2); margin: 16px 0;">
        <strong style="color: #F87171;">CONTAMINATION EXTRÊME / NÉGLIGENCE</strong><br>
        • Tarif horaire : à partir de €60,00/h par employé<br>
        • Prix indicatif : à partir de €10,00/m²<br>
        • Appartement : €900–€1.800+ | Maison/villa : €1.400–€3.500+<br>
        <span style="color: #A1A1AA;">Toujours devis sur mesure après visite ou photos.</span><br><br>
        <hr style="border-color: rgba(255,255,255,0.2); margin: 16px 0;">
        <strong>SUPPLÉMENTS :</strong><br>
        • Logement fumeur (nicotine sur murs/fenêtres) : +25%<br>
        • Animaux avec beaucoup de poils/odeurs : +15%<br>
        • Négligence grave / beaucoup de mobilier : devis sur mesure<br>
        <span style="color: #A1A1AA;">Le coût total peut atteindre €2.000–€5.000+ pour débarras + nettoyage en profondeur combinés.</span><br><br>
        Frais de déplacement : gratuit jusqu'à 15 km
      `
    }
  },

  de: {
    "vakantiehuizen": {
      title: "Ferienhäuser Service",
      subtitle: "Komplettreinigung, Wäscheservice und Gäste-Check-in für Ferienunterkünfte",
      intro: "Als Vermieter einer Ferienunterkunft wissen Sie, wie wichtig ein sauberer und einladender Raum für positive Bewertungen und wiederkehrende Gäste ist. Unser Ferienhäuser Service bietet eine Komplettlösung: professionelle Reinigung, Wäscheservice und Gäste-Check-in zwischen jedem Gästewechsel.",
      benefits: [
        { title: "Zeitersparnis", text: "Sie müssen nicht mehr selbst putzen, Wäsche waschen oder Gäste empfangen. Wir erledigen alles zwischen den Buchungen." },
        { title: "Bessere Bewertungen", text: "Eine blitzsaubere Unterkunft und persönlicher Empfang führen zu besseren Bewertungen und mehr Buchungen." },
        { title: "Flexible Planung", text: "Wir richten uns nach Ihrem Buchungskalender, auch bei Last-Minute-Wechseln." },
        { title: "Zuverlässiges Team", text: "Feste Mitarbeiter, die Ihre Immobilie kennen und nach Checkliste arbeiten." }
      ],
      whatWeOffer: [
        "Gründliche Reinigung aller Zimmer, Küche und Badezimmer",
        "Bettwäsche wechseln mit frischer, gewaschener Wäsche",
        "Handtücher ersetzen und ordentlich aufhängen",
        "Mülleimer leeren und Abfall entsorgen",
        "Vorräte prüfen (Toilettenpapier, Seife, Kaffee etc.)",
        "Geräte überprüfen (Kühlschrank, Backofen, Kaffeemaschine)",
        "Fenster putzen bei Bedarf",
        "Wäscheservice: alle benutzte Textilien waschen, trocknen und bügeln",
        "Qualitätskontrolle mit Fotobericht",
        "Gäste-Check-in: persönlicher Empfang mit Schlüsselübergabe und Hausführung",
        "Gäste-Check-in: Schlüssel in Schlüsselbox bereitgelegt mit Anweisungen"
      ],
      pricing: `
        <strong>ALL-IN PREIS pro Wechsel (zzgl. MwSt.):</strong><br>
        <span style="color: #A1A1AA;">Inklusive: Reinigung, Betten machen, Handtücher, Küche, Badezimmer.</span><br><br>
        <strong>Studio/Apartment bis 50m²:</strong> 1 SZ: €65<br>
        <strong>Wohnung 50-80m²:</strong> 1 SZ: €80 / 2 SZ: €95<br>
        <strong>Haus 80-120m²:</strong> 2 SZ: €120 / 3 SZ: €145 / 4 SZ: €160<br>
        <strong>Großes Haus 120-180m²:</strong> 3 SZ: €175 / 4 SZ: €195 / 5 SZ: €220<br>
        <strong>Villa >180m²:</strong> ab €230 — individuelles Angebot<br><br>
        <hr style="border-color: rgba(255,255,255,0.2); margin: 16px 0;">
        <strong>GÄSTE-CHECK-IN SERVICE (separat buchbar):</strong><br><br>
        <strong>Option 1 - Persönlicher Empfang:</strong> €45,00<br>
        <span style="color: #A1A1AA;">Mitarbeiter begrüßt die Gäste, übergibt Schlüssel, führt durchs Haus und erklärt die Hausordnung. (1 Stunde)</span><br><br>
        <strong>Option 2 - Schlüsselübergabe:</strong> €20,00<br>
        <span style="color: #A1A1AA;">Schlüssel in Schlüsselbox/Übergabepunkt bereitgelegt, Anweisungen hinterlegt.</span><br><br>
        <hr style="border-color: rgba(255,255,255,0.2); margin: 16px 0;">
        <strong>WÄSCHESERVICE ZUSCHLAG:</strong> €6,00/kg<br><br>
        <strong>RABATTE:</strong><br>
        - Check-in + Reinigung am selben Tag: €10,00 Rabatt auf Check-in<br>
        - 10+ Wechsel/Monat: 15% Rabatt<br>
        - 20+ Wechsel/Monat: 20% Rabatt
      `
    },
    "kantoorschoonmaak": {
      title: "Büroreinigung",
      subtitle: "Professionelle Reinigung für eine produktive Arbeitsumgebung",
      intro: "Ein sauberes Büro ist essentiell für die Gesundheit, Produktivität und das Image Ihres Unternehmens. Unsere professionelle Büroreinigung sorgt täglich oder regelmäßig für einen hygienischen und repräsentativen Arbeitsplatz.",
      benefits: [
        { title: "Gesündere Mitarbeiter", text: "Weniger Krankheitstage durch eine hygienische Arbeitsumgebung." },
        { title: "Professionelles Image", text: "Beeindrucken Sie Kunden und Besucher mit einem gepflegten Büro." },
        { title: "Flexible Zeiten", text: "Reinigung außerhalb der Bürozeiten, damit Sie nicht gestört werden." },
        { title: "Zuverlässig & Diskret", text: "Überprüftes Personal, das vertraulich mit Ihren Räumlichkeiten umgeht." }
      ],
      whatWeOffer: [
        "Tägliches Staubsaugen und Wischen der Böden",
        "Abstauben von Schreibtischen, Schränken und Oberflächen",
        "Leeren von Papierkörben und Abfallbehältern",
        "Reinigung der Sanitäranlagen",
        "Reinigung von Küche und Kantine",
        "Fensterreinigung (innen und außen)",
        "Tiefenreinigung von Teppichen und Bodenbelägen",
        "Regelmäßige Grundreinigung",
        "Desinfektion von Kontaktpunkten (Türklinken, Lichtschalter)"
      ],
      pricing: "Preis abhängig von Bürogröße, Häufigkeit und gewünschten Leistungen. Fordern Sie ein Angebot an."
    },
    "industriele-reiniging": {
      title: "Industriereinigung",
      subtitle: "Spezialisierte Reinigung für Fabriken und Lagerhallen",
      intro: "Industrielle Umgebungen stellen hohe Anforderungen an die Reinigung. Von Produktionshallen bis zu Lagern - unsere Spezialisten verfügen über das Wissen und die Ausrüstung für gründliche, sichere und effiziente Reinigung.",
      benefits: [
        { title: "Sicherheit Zuerst", text: "Vermeiden Sie Unfälle durch rutschige Böden oder herumliegenden Abfall." },
        { title: "Weniger Ausfälle", text: "Saubere Maschinen und Anlagen funktionieren besser und halten länger." },
        { title: "Normenkonform", text: "Erfüllen Sie HACCP, IFS und andere Hygienestandards." },
        { title: "Minimale Ausfallzeit", text: "Wir arbeiten nachts oder in ruhigen Stunden." }
      ],
      whatWeOffer: [
        "Reinigung von Maschinen und Produktionslinien",
        "Reinigung von Lagerregalen und Ablagen",
        "Bodenreinigung mit industriellen Scheuersaugmaschinen",
        "Dampfreinigung zur chemiefreien Desinfektion",
        "Hochdruckreinigung von Oberflächen",
        "Entfernung von Öl, Fett und Produktionsrückständen",
        "Reinigung von Rohrleitungen, Tanks und Zubehör",
        "Abfallmanagement und Aufräumen",
        "Regelmäßige Tiefenreinigung"
      ],
      pricing: "Preis auf Anfrage, abhängig von Fläche, Art der Verschmutzung und Häufigkeit."
    },
    "ramenwassen-osmose": {
      title: "Osmose Fensterreinigung",
      subtitle: "Streifenfreie Ergebnisse mit reinem Osmosewasser",
      intro: "Osmose-Fensterreinigung ist die moderne, umweltfreundliche Methode für kristallklare Fenster. Leitungswasser wird unter hohem Druck durch eine feine Membran gepresst, wodurch nahezu alle Mineralien und Verunreinigungen herausgefiltert werden. Das Ergebnis: hochreines Wasser, das Schmutz vom Glas löst und völlig streifenfrei trocknet — ganz ohne Reinigungsmittel.",
      warning: "Osmosewasser darf NICHT auf goldfarbenen Aluminium-Fensterrahmen verwendet werden! Das reine Wasser kann die goldfarbene Beschichtung beschädigen. Haben Sie goldfarbene Rahmen? Kontaktieren Sie uns für eine alternative Lösung.",
      benefits: [
        { title: "100% Streifenfrei", text: "Osmosewasser trocknet ohne Streifen oder Kalkflecken." },
        { title: "Umweltfreundlich", text: "Keine Chemikalien, sicher für Mensch, Tier und Pflanze." },
        { title: "Bleibt Länger Sauber", text: "Fenster bleiben länger sauber, da keine Seifenreste Schmutz anziehen." },
        { title: "Sicheres Arbeiten", text: "Bis zu 6 Meter Höhe ohne Leiter dank Teleskopsystem." }
      ],
      whatWeOffer: [
        "Fensterreinigung mit gereinigtem Osmosewasser",
        "Teleskopsystem bis 6 Meter - ohne Leiter",
        "Alle Fenstertypen: Standard, Schiebetüren, Dachfenster",
        "Rahmen und Fensterbänke inklusive",
        "Keine Chemikalien oder aggressive Mittel",
        "Geeignet für Wohnungen, Büros und Geschäfte",
        "Abonnements mit Rabatt möglich",
        "Alternative für goldfarbene Aluminiumrahmen verfügbar"
      ],
      pricing: `
        <div style="background: rgba(239, 68, 68, 0.1); border: 1px solid rgba(239, 68, 68, 0.3); border-radius: 8px; padding: 16px; margin-bottom: 20px;">
          <strong style="color: #EF4444;">ACHTUNG - GOLDFARBENES ALUMINIUM</strong><br>
          <span style="color: #FCA5A5;">Osmosewasser darf NICHT auf goldfarbenen Aluminiumrahmen verwendet werden. Bei goldfarbenem Aluminium reinigen wir traditionell manuell (siehe Preise unten).</span>
        </div>
        <strong>OSMOSE-PREISE pro Fenster (zzgl. MwSt.):</strong><br>
        <em>Standardmethode - nicht für goldfarbenes Aluminium</em><br><br>
        <strong>Standardfenster (bis 1,5m²):</strong><br>
        • Außen: €4,50<br>• Innen: €3,00<br>• Innen + außen: €7,00<br><br>
        <strong>Großes Fenster (Schiebetür, 1,5-3m²):</strong><br>
        • Außen: €9,00<br>• Innen: €5,00<br>• Innen + außen: €13,00<br><br>
        <strong>Dachfenster/Velux:</strong><br>
        • Außen: €10,00<br>• Innen + außen: €15,00<br><br>
        <hr style="border-color: rgba(255,255,255,0.2); margin: 20px 0;">
        <strong>TRADITIONELL MANUELL pro Fenster (zzgl. MwSt.):</strong><br>
        <em>Für goldfarbene Aluminiumrahmen</em><br><br>
        <strong>Standardfenster (bis 1,5m²):</strong><br>
        • Außen: €5,50<br>• Innen: €3,50<br>• Innen + außen: €8,50<br><br>
        <strong>Großes Fenster (Schiebetür, 1,5-3m²):</strong><br>
        • Außen: €11,00<br>• Innen: €6,00<br>• Innen + außen: €16,00<br><br>
        <strong>Dachfenster/Velux:</strong><br>
        • Außen: €12,00<br>• Innen + außen: €18,00<br><br>
        <hr style="border-color: rgba(255,255,255,0.2); margin: 20px 0;">
        <strong>EXTRA GROSSE FENSTER (≥ 4m², Schaufenster, Glasfassaden) pro m²:</strong><br><br>
        <strong>Osmose (zzgl. MwSt.):</strong><br>
        • Außen: €2,00–€2,50/m²<br>
        • Volumen/Unternehmen (viel Glas): €1,60–€2,00/m²<br>
        • Innen + außen: €3,00–€4,00/m²<br><br>
        <strong>Traditionell manuell (zzgl. MwSt.):</strong><br>
        • Außen: €2,50–€3,00/m²<br>
        • Innen + außen: €3,50–€4,50/m²<br><br>
        <hr style="border-color: rgba(255,255,255,0.2); margin: 20px 0;">
        Mindesttarif: €35,00 pro Besuch<br>
        Anfahrtskosten: kostenlos bis 15 km
      `
    },
    "zonnepanelen-reiniging": {
      title: "Solaranlagen Reinigung",
      subtitle: "Steigern Sie Ihren Ertrag um bis zu 30% mit sauberen Modulen",
      intro: "Verschmutzte Solarmodule produzieren weniger Energie. Staub, Vogelkot, Blätter und Saharastaub können den Ertrag um 5-20% reduzieren. Unsere professionelle Reinigung mit Osmosewasser stellt die optimale Leistung Ihrer Anlage wieder her.",
      benefits: [
        { title: "Mehr Ertrag", text: "Saubere Module liefern bis zu 15-20% mehr Energie." },
        { title: "Längere Lebensdauer", text: "Vermeiden Sie dauerhafte Schäden durch Vogelkot und Schmutz." },
        { title: "Osmosewasser", text: "Keine Chemikalien, sicher für Ihre Module und die Umwelt." },
        { title: "Garantie Erhalten", text: "Viele Hersteller verlangen Wartung für die Garantie." }
      ],
      whatWeOffer: [
        "Reinigung mit reinem Osmosewasser (keine Chemikalien)",
        "Sicheres Arbeiten mit Teleskopsystem",
        "Inspektion auf sichtbare Schäden",
        "Geeignet für alle Modultypen",
        "Wohn- und Gewerbeanlagen",
        "Jährliches Wartungsabonnement möglich",
        "Flexible Terminplanung im Frühjahr oder Spätsommer"
      ],
      pricing: "Preis abhängig von Anzahl der Module und Erreichbarkeit. Durchschnittlich €3-5 pro Modul. Fordern Sie ein Angebot an."
    },
    "wasserijdiensten": {
      title: "Wäscheservice",
      subtitle: "Professionelle Textilpflege über HomeCareService",
      intro: "Unser Wäscheservice über HomeCareService bietet professionelle Textilpflege für Unternehmen. Von Arbeitskleidung bis Bettwäsche - wir kümmern uns um Abholung, Waschen, Trocknen, Bügeln und Rücklieferung Ihrer Textilien.",
      benefits: [
        { title: "Zeitersparnis", text: "Konzentrieren Sie sich auf Ihr Kerngeschäft, wir kümmern uns um die Wäsche." },
        { title: "Professionelle Qualität", text: "Industriemaschinen und Expertise für perfekte Ergebnisse." },
        { title: "Umweltbewusst", text: "Energiesparende Maschinen und umweltfreundliche Produkte." },
        { title: "Persönlicher Service", text: "Fester Ansprechpartner und flexible Abholzeiten." }
      ],
      whatWeOffer: [
        "Abholung und Lieferung vor Ort",
        "Waschen, Trocknen und Bügeln",
        "Arbeitskleidung und Uniformen",
        "Bettwäsche und Handtücher",
        "Tischdecken und Servietten (Gastronomie)",
        "Inspektion und kleine Reparaturen",
        "Flexible Frequenz: täglich bis wöchentlich"
      ],
      pricing: `
        <strong>B2B-Tarif:</strong><br>
        Waschen, Trocknen und Bügeln: <strong>€6,- pro kg</strong> (zzgl. MwSt.)<br><br>
        <a href="https://homecareservice.me/prijslijst-1" target="_blank" rel="noopener noreferrer" class="text-[#4DD0E1] hover:underline">
          → Vollständige Preisliste auf HomeCareService ansehen
        </a>
      `
    },
    "glazenwassen": {
      title: "Traditionelle Fensterreinigung",
      subtitle: "Klassische Fensterreinigung für kristallklare Fenster",
      intro: "Neben der Osmose-Fensterreinigung bieten wir auch traditionelle Fensterreinigung an. Diese Methode ist ideal für bestimmte Situationen wie Innenfenster oder wenn manuelle Nachbearbeitung gewünscht ist.",
      benefits: [
        { title: "Detailarbeit", text: "Manuelle Nachbearbeitung für perfekte Ecken und Kanten." },
        { title: "Innenfenster-Spezialist", text: "Ideal für Innenfenster ohne Wassertropfen." },
        { title: "Erfahrene Fachkräfte", text: "Jahrelange Erfahrung mit allen Glasarten." },
        { title: "Zuverlässig", text: "Die gleiche Qualität, die Sie von uns gewohnt sind." }
      ],
      whatWeOffer: [
        "Traditionelle Fensterreinigung mit Abzieher und Tuch",
        "Innenseite der Fenster",
        "Spiegel und Glastrennwände",
        "Schwer erreichbare Ecken",
        "Kombination mit Osmose für Außenseite",
        "Büros, Geschäfte und Wohnungen"
      ],
      pricing: `
        <strong>Preise pro Fenster (zzgl. MwSt.):</strong><br><br>
        <strong>Standardfenster (bis 1,5m²):</strong><br>
        • Innen: €3,00<br><br>
        <strong>Großes Fenster (1,5-3m²):</strong><br>
        • Innen: €5,00<br><br>
        <strong>Extra großes Fenster (≥ 4m², Schaufenster, Fassaden):</strong><br>
        • Innen: €2,00–€2,50/m²<br>
        • Innen + außen: €3,00–€4,00/m²<br><br>
        Außenseite wird immer mit Osmose gereinigt.
      `
    },
    "sanering-desinfectie": {
      title: "Sanierung & Desinfektionsreinigung",
      subtitle: "Professionelle Reinigung nach Toilettenverstopfungen, Rohrbrüchen und Abwasserschäden",
      intro: "Wasserschäden durch eine verstopfte Toilette, ein geplatztes Rohr oder einen Kanalbruch sind nicht nur unangenehm — sie können auch ein ernstes Gesundheitsrisiko darstellen. Abwasser enthält Bakterien, Viren und Schimmelpilze, die professionell entfernt werden müssen. Clean-Force bietet schnelle und gründliche Sanierung und Desinfektionsreinigung.",
      benefits: [
        { title: "Schneller Einsatz", text: "Bei Notfällen sind wir schnell vor Ort. Wir wissen, dass bei Wasserschäden jede Minute zählt." },
        { title: "Zertifizierte Desinfektion", text: "Wir verwenden professionelle Desinfektionsmittel, die Bakterien, Viren und Schimmelpilze wirksam beseitigen." },
        { title: "Spezialisiertes Team", text: "Unsere Mitarbeiter sind in der Sanierung nach Wasserschäden geschult und arbeiten mit angemessener Schutzausrüstung." },
        { title: "Vollständige Wiederherstellung", text: "Vom Abpumpen bis zur Desinfektion und Geruchsbehandlung — Ihr Raum wird wieder 100% sauber und sicher." }
      ],
      whatWeOffer: [
        "Inspektion und Schadensbewertung",
        "Entfernung von kontaminiertem Wasser und Abfall",
        "Gründliche Reinigung aller betroffenen Oberflächen",
        "Professionelle Desinfektion mit zertifizierten Produkten",
        "Schimmelprevention und Geruchsbehandlung",
        "Reinigung und Desinfektion von Sanitäranlagen",
        "Reinigung von Böden, Wänden und Sockelleisten nach Leckage",
        "Trocknungs- und Belüftungsberatung",
        "Dokumentation und Berichterstattung für Versicherungsansprüche",
        "Nachsorge und Kontrolle nach Behandlung"
      ],
      pricing: `
        <strong>TARIFE SANIERUNG & DESINFEKTION (ohne MwSt.):</strong><br>
        <span style="color: #A1A1AA;">Preise hängen von Umfang und Schwere der Verunreinigung ab.</span><br><br>
        <hr style="border-color: rgba(255,255,255,0.2); margin: 16px 0;">
        <strong>Starttarif (erste Stunde, inkl. Anfahrtskosten):</strong> €149,00<br><br>
        <strong>Folge pro Viertelstunde:</strong> €32,50<br><br>
        <hr style="border-color: rgba(255,255,255,0.2); margin: 16px 0;">
        <strong>PAKETPREISE:</strong><br><br>
        <strong>Toilettenverstopfung + Desinfektion:</strong> ab €175,00<br><br>
        <strong>Rohrbruch / Leck — kleiner Bereich (bis 20m²):</strong> ab €350,00<br><br>
        <strong>Abwasserschaden — mittlerer Bereich (20-60m²):</strong> ab €750,00<br><br>
        <strong>Große Sanierung (>60m² oder mehrere Räume):</strong> individuelles Angebot<br><br>
        <hr style="border-color: rgba(255,255,255,0.2); margin: 16px 0;">
        <strong>ZUSCHLÄGE:</strong><br>
        • Abend (18:00 - 22:00): +25%<br>
        • Wochenende: +50%<br>
        • Dringend / Feiertage: +75%
      `
    },
    "bouwoplevering": {
      title: "Bauendreinigung",
      subtitle: "Bezugsfertige Übergabereinigung nach Neubau oder Renovierung",
      intro: "Nach Bau- oder Renovierungsarbeiten ist Ihr Gebäude voller Baustaub, Zementreste und Farbspritzer. Clean-Force liefert eine bezugsfertige Übergabereinigung.",
      benefits: [
        { title: "Gründliche Entstaubung", text: "Baustaub setzt sich überall fest — wir entfernen ihn aus jeder Ecke und Ritze." },
        { title: "Professionelle Mittel", text: "Zementreste und Farbspritzer werden mit Spezialprodukten schadenfrei entfernt." },
        { title: "Pünktliche Lieferung", text: "Wir arbeiten schnell und effizient, damit Ihr Übergabetermin nicht gefährdet wird." },
        { title: "Bezugsfertiges Ergebnis", text: "Ihre Immobilie wird geliefert, als wäre sie nie eine Baustelle gewesen." }
      ],
      whatWeOffer: [
        "Entfernung grober Baureste und Schutzfolien",
        "Intensive Entstaubung aller Oberflächen",
        "Fensterreinigung innen (inkl. Rahmen)",
        "Entfernung von Zement-, Kalk- und Farbspritzern",
        "Reinigung der Sanitäranlagen",
        "Gründliche Küchenreinigung",
        "Bodenreinigung und Wischen",
        "Sockelleisten, Türrahmen und Lichtschalter",
        "Treppengeländer und Balustraden",
        "Lüftungsgitter und Heizkörper"
      ],
      pricing: `
        <strong>BAUENDREINIGUNG TARIFE (zzgl. MwSt.):</strong><br><br>
        <strong>Stundensatz:</strong> Ab €45,00/Stunde pro Mitarbeiter<br><br>
        <strong>Richtpreis:</strong> Ab €6,00/m²<br>
        <span style="color: #A1A1AA;">Abhängig von Verschmutzungsgrad, Erreichbarkeit und Fensteranzahl.</span><br><br>
        Anfahrtskosten: kostenlos bis 15 km
      `
    },
    "schoonmaak-na-verhuur": {
      title: "Reinigung nach Vermietung/Verkauf",
      subtitle: "Immobilie übergabefertig nach Vermietung, Verkauf oder Umzug",
      intro: "Beim Verlassen einer Mietwohnung oder nach einem Verkauf erwartet der nächste Bewohner eine saubere und bezugsfertige Wohnung. Clean-Force sorgt für eine gründliche Tiefenreinigung.",
      benefits: [
        { title: "Kautionsrückgabe", text: "Eine professionell gereinigte Wohnung erhöht die Chance auf vollständige Kautionsrückgabe erheblich." },
        { title: "Tiefenreinigung", text: "Nicht nur oberflächlich — wir reinigen Schränke, Geräte, Sanitär und Böden bis ins Detail." },
        { title: "Erfahrenes Team", text: "Unser Team hat umfangreiche Erfahrung mit Auszugs- und Übergabereinigung." },
        { title: "Bezugsfertig", text: "Der nächste Bewohner kann sofort einziehen." }
      ],
      whatWeOffer: [
        "Tiefenreinigung Küche (Ofen, Kühlschrank, Dunstabzug, Schränke)",
        "Gründliche Reinigung und Entkalkung der Sanitäranlagen",
        "Alle Böden saugen und wischen",
        "Fensterreinigung innen inkl. Rahmen",
        "Schränke und Schubladen innen reinigen",
        "Sockelleisten und Türklinken",
        "Lichtschalter und Steckdosen",
        "Spinnweben entfernen",
        "Heizkörper und Lüftungsgitter",
        "Balkon oder Terrasse kehren"
      ],
      pricing: `
        <strong>REINIGUNG NACH VERMIETUNG/VERKAUF (zzgl. MwSt.):</strong><br><br>
        <strong>Stundensatz:</strong> Ab €45,00/Stunde pro Mitarbeiter<br><br>
        <strong>Richtpreis:</strong> Ab €4,00/m²<br><br>
        <hr style="border-color: rgba(255,255,255,0.2); margin: 16px 0;">
        <strong>PAKETPREISE PRO WOHNUNGSTYP (ab, zzgl. MwSt.):</strong><br><br>
        • Studio / 1 Schlafzimmer (bis 50m²): ab €250<br>
        • Wohnung 2-3 Schlafzimmer (50-100m²): ab €375<br>
        • Familienhaus (100-150m²): ab €550<br>
        • Großes Haus (150-250m²): ab €850<br>
        • Villa (>250m²): ab €1.250<br><br>
        <strong>ZUSCHLÄGE:</strong><br>
        • Raucherwohnung: +25%<br>
        • Haustiere: +15%<br><br>
        Anfahrtskosten: kostenlos bis 15 km
      `
    },
    "deepclean": {
      title: "Grundreinigung",
      subtitle: "Gründliche Tiefenreinigung von normaler bis extremer Verschmutzung",
      intro: "Eine Grundreinigung geht über die Standardreinigung hinaus. Wir reinigen Ihre Wohnung oder Ihr Gebäude von oben bis unten, bis ins kleinste Detail.",
      benefits: [
        { title: "Bis ins Detail", text: "Hinter Geräten, in Schränken, über Türen — kein Fleck wird ausgelassen." },
        { title: "Professionelle Mittel", text: "Wir verwenden industrielle Reinigungsmittel, die tief reinigen ohne Ihre Materialien zu beschädigen." },
        { title: "Flexibel Planbar", text: "Einmalig oder regelmäßig. Sie bestimmen wann und wie oft." },
        { title: "Erfahrene Spezialisten", text: "Unser Team ist geschult im Umgang mit schwerer Verschmutzung, Nikotin und Verwahrlosung." }
      ],
      whatWeOffer: [
        "Gründliche Reinigung aller Böden",
        "Küchen-Tiefenreinigung (Ofen, Kühlschrank, Dunstabzug, Schränke)",
        "Sanitär-Tiefenreinigung und Entkalkung",
        "Fenster innen inkl. Rahmen und Fensterbänke",
        "Alle Schränke und Schubladen innen",
        "Sockelleisten, Türrahmen und Lichtschalter",
        "Heizkörper und Lüftungsgitter",
        "Spinnweben entfernen",
        "Hinter und unter Geräten/Möbeln",
        "Fett- und Nikotinentfernung",
        "Schimmelbehandlung",
        "Wand- und Deckenreinigung"
      ],
      pricing: `
        <strong>GRUNDREINIGUNG TARIFE (zzgl. MwSt.):</strong><br><br>
        <strong style="color: #4DD0E1;">NORMALE GRUNDREINIGUNG</strong><br>
        • Stundensatz: ab €50,00/Stunde pro Mitarbeiter<br>
        • Richtpreis: ab €5,00–€6,00/m²<br>
        • Wohnung: ab €500–€1.000 | Haus: ab €800–€1.800<br><br>
        <hr style="border-color: rgba(255,255,255,0.2); margin: 16px 0;">
        <strong style="color: #F87171;">EXTREME VERSCHMUTZUNG / VERWAHRLOSUNG</strong><br>
        • Stundensatz: ab €60,00/Stunde pro Mitarbeiter<br>
        • Richtpreis: ab €10,00/m²<br>
        • Wohnung: €900–€1.800+ | Haus/Villa: €1.400–€3.500+<br>
        <span style="color: #A1A1AA;">Immer individuelles Angebot nach Besichtigung oder Fotos.</span><br><br>
        <hr style="border-color: rgba(255,255,255,0.2); margin: 16px 0;">
        <strong>ZUSCHLÄGE:</strong><br>
        • Raucherwohnung (Nikotin an Wänden/Fenstern): +25%<br>
        • Haustiere mit viel Haar/Geruch: +15%<br>
        • Schwere Verwahrlosung / viel Mobiliar: individuelles Angebot<br>
        <span style="color: #A1A1AA;">Gesamtkosten können €2.000–€5.000+ erreichen bei Entrümpelung + Grundreinigung zusammen.</span><br><br>
        Anfahrtskosten: kostenlos bis 15 km
      `
    }
  }
};

export default serviceTranslations;
